import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { LogReporterService } from "@app/service/log-reporter.service";
import { catchError, throwError } from "rxjs";

@Injectable()
export class NetworkErrorInterceptor implements HttpInterceptor {

  private _logReporter = inject(LogReporterService);
  
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const startedAt = performance.now();
    const errorHandler = this._logReporter.errorLogger("app")

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error(error);

        if (error.status === 0) {
          errorHandler(error)
          
          console.error('[HTTP STATUS 0]', {
            url: req.url,
            method: req.method,
            elapsedMs: performance.now() - startedAt,
            online: navigator.onLine,
            headers: req.headers.keys(),
            error
          });
        }

        return throwError(() => error);
      })
    );
  }
}
